<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      rows-per-page-text="Linhas por página"
      no-data-text="Não há dados"
      sort-by="changed_date"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.after_changed }}</td>
        <td class="text-xs-left">{{ props.item.changed_user }}</td>
        <td class="text-xs-left">{{ props.item.changed_date | moment("DD/MM/YYYY HH:mm:ss") }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'SystemLogs',

  props: {
    tableData: { type: Array, required: true }
  },

  data () {
    return {
      headers: [
        // { text: 'Descrição produto', sortable: true, value: 'name_fantasy', align: 'left' },
        { text: 'Alteração', value: 'after_changed', align: 'left', sortable: false },
        { text: 'Usuário alteração', value: 'changed_user', sortable: false, align: 'left' },
        { text: 'Data alteração', value: 'changed_date', sortable: false, align: 'left' }
      ],
      tableRows: []
    }
  }
}
</script>

<style>

</style>
